import { render, staticRenderFns } from "./address-nav.vue?vue&type=template&id=40d1d2ff&scoped=true"
import script from "./address-nav.vue?vue&type=script&lang=js"
export * from "./address-nav.vue?vue&type=script&lang=js"
import style0 from "./address-nav.vue?vue&type=style&index=0&id=40d1d2ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1d2ff",
  null
  
)

export default component.exports